export class TRCNextSteps {
    exemptFormReq : any
    internetFormReq : any
    multimediaFormReq : any
    setupPlcCryWolfPermit : any
	setupPlcMedallionPermit : any
	setupFrePermit : any 
	setupTbcPermit : any
    addlTaxWarning : any
    
}